<template>
  <div class="flex justify-end p-4 mt-5" v-if="num > 1">
    <ul v-for="index in num" :key="index">
      <li
        @click="handleClick(index)"
        class="p-3 border mr-2 rounded hover:bg-STorange cursor-pointer text-xs"
      >
        {{ index }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ExtraPages",

  props: {
    num: Number,
  },

  methods: {
    handleClick(index) {
      this.$emit("handleClick", index);
    },
  },
};
</script>